/**
 * PERFORMANCE: Core theme initialization
 * Extracted from inline scripts to reduce blocking time
 * Expected improvement: -300ms to -500ms TBT
 */

// Initialize theme configuration
window.theme = window.theme || {};

// Media queries and device detection
window.theme.mediaMatches = window.theme.mediaMatches || {};
Object.keys(window.theme.mediaQueries || {}).forEach(function(key) {
  window.theme.mediaMatches[key] = window.matchMedia(window.theme.mediaQueries[key]).matches;
});

window.theme.device = {
  hasTouch: window.matchMedia('(any-pointer: coarse)').matches,
  hasHover: window.matchMedia('(hover: hover)').matches,
  isMobile: window.innerWidth < 769,
  isTablet: window.innerWidth >= 769 && window.innerWidth < 1024,
  isDesktop: window.innerWidth >= 1024
};

// Update device detection on resize (debounced)
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    window.theme.device.isMobile = window.innerWidth < 769;
    window.theme.device.isTablet = window.innerWidth >= 769 && window.innerWidth < 1024;
    window.theme.device.isDesktop = window.innerWidth >= 1024;

    Object.keys(window.theme.mediaQueries || {}).forEach(function(key) {
      window.theme.mediaMatches[key] = window.matchMedia(window.theme.mediaQueries[key]).matches;
    });
  }, 250);
}, { passive: true });

// Lazy script loader for heavy interactive features
window.lazyLoadScript = function(src, condition) {
  if (condition && !document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }
};
